import classNames from "classnames";
import React from "react";
import { MainWidthClassName, SectionPaddingClassName } from "../styles";
import { CollectionProps } from "./Collection";

export const TeamCollection: React.FC<CollectionProps> = ({
  contents,
  className,
  title,
  showTitle,
}) => {
  return (
    <section
      data-component="Team Collection"
      className={classNames("gap-y-90px", SectionPaddingClassName, className)}
    >
      {showTitle && (
        <div className="page-grid max-midth relative mb-40px">
          <h3 className="h3 col-span-12 md:col-start-3">{title}</h3>
        </div>
      )}
      <div className="page-grid max-width relative">
        <div
          className={classNames(
            MainWidthClassName,
            "grid grid-cols-2 gap-y-90px md:grid-cols-6",
            "md:gap-x-40px",
          )}
        >
          {contents.map((c, i) => {
            return (
              <div
                key={i}
                className={classNames(
                  "col-span-2",
                  i % 5 === 3 && "md:col-start-2",
                  "md:col-span-2",
                  "max-w-250px",
                )}
              >
                {c.content}
              </div>
            );
          })}
        </div>
      </div>{" "}
    </section>
  );
};
